import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const BbxStepper03Icon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M20.25 3.75L23 5L20.25 6.25L19 9L17.75 6.25L15 5L17.75 3.75L19 1L20.25 3.75ZM20.25 17.75L23 19L20.25 20.25L19 23L17.75 20.25L15 19L17.75 17.75L19 15L20.25 17.75Z"
            fill="#222"
          />
          <path
            d="M8.99998 20.4C13.6392 20.4 17.4 16.6392 17.4 12C17.4 7.36081 13.6392 3.6 8.99998 3.6C4.36078 3.6 0.599976 7.36081 0.599976 12C0.599976 16.6392 4.36078 20.4 8.99998 20.4ZM7.46398 16.056C7.91198 16.248 8.41198 16.344 8.96398 16.344C9.58798 16.344 10.112 16.228 10.536 15.996C10.968 15.764 11.296 15.456 11.52 15.072C11.744 14.688 11.856 14.264 11.856 13.8C11.856 13.248 11.708 12.792 11.412 12.432C11.116 12.064 10.732 11.832 10.26 11.736C10.644 11.624 10.964 11.408 11.22 11.088C11.484 10.76 11.616 10.36 11.616 9.888C11.616 9.48 11.512 9.108 11.304 8.772C11.104 8.436 10.804 8.168 10.404 7.968C10.012 7.76 9.52798 7.656 8.95198 7.656C8.14398 7.656 7.48398 7.88 6.97198 8.328C6.46798 8.776 6.19998 9.388 6.16798 10.164H7.66798C7.69198 9.828 7.81198 9.544 8.02798 9.312C8.25198 9.08 8.55998 8.964 8.95198 8.964C9.31198 8.964 9.59198 9.06 9.79198 9.252C9.99998 9.436 10.104 9.684 10.104 9.996C10.104 10.372 9.96798 10.656 9.69598 10.848C9.42398 11.04 9.08398 11.136 8.67598 11.136H8.03998V12.396H8.66398C9.15998 12.396 9.56398 12.512 9.87598 12.744C10.196 12.968 10.356 13.3 10.356 13.74C10.356 14.116 10.236 14.428 9.99598 14.676C9.75598 14.924 9.41198 15.048 8.96398 15.048C8.49198 15.048 8.12398 14.912 7.85998 14.64C7.60398 14.36 7.47198 14.016 7.46398 13.608H5.95198C5.96798 14.224 6.11198 14.736 6.38398 15.144C6.65598 15.552 7.01598 15.856 7.46398 16.056Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
